import { render, staticRenderFns } from "./AlumniRequestView.vue?vue&type=template&id=73b4ad41"
import script from "./AlumniRequestView.vue?vue&type=script&lang=js"
export * from "./AlumniRequestView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports